/**
 * SDX Internationalization - `t()` and `formatPlural()`.
 *
 * An alias of the runtime implementation so `@sdx/i18n` and
 * `@sdx/runtime` cannot drift (this file used to carry a second copy
 * whose fallback replaced only the first placeholder and dropped the
 * options argument). Both guard on `Drupal` being defined, so the pair
 * works in the browser, in tests and under SSR alike.
 * Import via: import { t } from '@sdx/i18n';
 */

export { t, formatPlural } from './runtime';
